import { useSelector } from "react-redux";
import { RootState } from "reducers";
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedOutlet() {
  const token = useSelector((state: RootState) => state.auth.token);
  return token ? <Outlet /> : <Navigate to="/" />;
}
